module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"yes":"Yes","no":"No","areYouSure":"Are you sure ?","delete":"Delete"},"fr":{"yes":"Oui","no":"Non","areYouSure":"Etes-vous sûr ?","delete":"Supprimer"},"de":{"yes":"Ja","no":"Nicht","areYouSure":"Bist du dir sicher ?","delete":"LÖSCHEN"}}')
  delete Component.options._Ctor
}
